import type { Cue } from '~shared/rundown/cue'
import type { RundownCueOrderItem } from '~shared/types'

import type { GetCue } from './buildIndexedCues'
import { flattenCueOrderItems } from './flattenCueOrderItems'

/**
 * Joins the cue order with the cue documents, returning cues in document order.
 *
 * The order tree is the authority on what belongs to the rundown, so cues that
 * exist but have no place in it are dropped, and cues named by the order whose
 * document is missing are skipped rather than left as holes.
 */
export function sortCuesByOrder(cueOrder: RundownCueOrderItem[], getCue: GetCue): Cue[] {
  const cues: Cue[] = []
  for (const cueId of flattenCueOrderItems(cueOrder)) {
    const cue = getCue(cueId)
    if (cue) cues.push(cue)
  }
  return cues
}
